import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { WidthProps, width } from 'styled-system';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

const PUBLIC_DOMAIN = getPublicRuntimeConfig('PUBLIC_DOMAIN');
const APP_TLD = getPublicRuntimeConfig('APP_TLD');
const ASSETS_URL = getPublicRuntimeConfig('ASSETS_URL');

const StyledLink = styled.a<WidthProps>`
  ${width};
  display: block;
  margin-top: -4px;
`;

const Image = styled.img`
  width: 100%;
`;

const logoWidth = ['100px', '100px', '137px'];

export const Logo: React.FC = (props) => {
  const altText = `${PUBLIC_DOMAIN}.${APP_TLD}`;
  const src = `${ASSETS_URL}/static/images/logo-${APP_TLD}.svg`;
  return (
    <Link prefetch={false} href="/">
      <StyledLink {...props} href="/" width={logoWidth}>
        <Image src={src} alt={altText} title={altText} data-testid="company-logo" />
      </StyledLink>
    </Link>
  );
};
